<template>
    <div class="w100 pl20 pr20 pt20 pb20" v-loading="loading">
        <div  class="title" style="background: #fff">签到记录</div>
        <Sift ref="needSift" :sift-data="siftData" v-if="siftData.length" @change="initPage" :col="5">
            <el-col class="flex-box al-c" :span="4">
                <el-button type="primary" @click="initPage">查询</el-button>
            </el-col>
        </Sift>

        <div class="table-con">
            <el-table
                    class="w100 mt20 table"
                    header-row-class-name="table-head"
                    @selection-change="handleSelectionChange"
                    row-class-name="cu-p"
                    stripe :data="list">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column align="center" label="序号" width="50px">
                    <template slot-scope="scope">
                        {{ paramSearch.current * paramSearch.size - paramSearch.size + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="name" label="课程名称"></el-table-column>
                <el-table-column align="center" prop="classrooms" label="上课教室"></el-table-column>
                <el-table-column align="center" prop="knob" label="课程节数"></el-table-column>
                <el-table-column align="center" prop="teachers" label="授课教师"></el-table-column>
                <el-table-column align="center" prop="knob" label="上课时间">
                    <template slot-scope="scope">
                        {{scope.row.date}} {{scope.row.timeRange}}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="attendanceTime" label="状态">
                    <template slot-scope="scope">
                        {{scope.row.status == '1' ? '正常' : scope.row.status == '2' ? '迟到' : scope.row.status == '3' ? '早退' : '缺勤'}}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="remark" label="操作">
                    <template slot-scope="scope">
                        <div class="to-use">
                            <span class="info" @click="seeInfo(scope.row)">详情</span>
                            <!--<span class="info" @click="setConment(scope.row)">评教</span>-->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="mt20 flex-box">
            <div class="flex-1"></div>
            <el-pagination background @size-change="changeSize"
                           @current-change="changePage"
                           :current-page="paramSearch.current"
                           :page-sizes="pageSizes"
                           :page-size="paramSearch.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total"
            ></el-pagination>
        </div>
        <myRecord :editData="editData"></myRecord>
        <!--<editComment :mentData="mentData"></editComment>-->
    </div>
</template>

<script>
    import Sift from "@/components/sift/Sift";
    import { getMyRecord} from '@/api/overseasChinese/overseasChinese';
    import myRecord from "./myRecord"
    // import editComment from './editComment'
    export default {
        name: "checkInRecord",
        components: {
            Sift,
            myRecord
        },
        props: [],
        data() {
            return {
                loading: false,
                siftData : [
                    {
                        type: "bedate",
                        key: "start,end",
                        label: "上课时间",
                        placeholder: "",
                        defaultValue: "",
                        indelible: true,
                        fixed: true,
                        pickerType: "datetime", // 传给时间组件的type = date、datetime
                        sysDatasourceQuery: true, //传给时间组件是否需要自选格式
                        optionalType: "yyyy-MM-dd HH:mm:ss" // 需要的时间格式
                    },
                    {
                        type: "select",
                        key: "status",
                        label: "签到状态",
                        placeholder: "请选择签到状态",
                        default: "",
                        data: [
                            {
                                label: '正常',
                                value: '1'
                            },
                            {
                                label: '迟到',
                                value: '2'
                            },
                            {
                                label: '早退',
                                value: '3'
                            },
                            {
                                label: '缺勤',
                                value: '4'
                            }
                        ]
                    },
                    {
                        type: "text",
                        key: "name",
                        label: "关键字",
                        placeholder: "教室/课程/教师",
                        default: ""
                    },
                ],
                list: [],
                pageSizes:[10, 20, 30, 50, 100],
                paramSearch:{
                    current:1,
                    size:10,
                },
                total: 0,
                selectList:[],
                dialogVisible: false,
                editData:{
                    state: false,
                    data:{}
                },
                // mentData:{
                //     state: false,
                //     data:{}
                // }
            };
        },
        computed: {},
        created() {},
        mounted() {
            let start = `${this.$moment().startOf('month').format('YYYY-MM-DD')} 00:00:00`;
            let end = `${this.$moment().endOf('month').format('YYYY-MM-DD')} 21:00:00`;
            this.$refs.needSift.setValue(`${start},${end}`)
            this.paramSearch={
                ...this.paramSearch,
                ...this.$refs.needSift.getValue(),
                current:1
            }
            this.getListFn();
        },
        methods: {
            // setConment(row){
            //     this.mentData.state = true
            //     this.mentData.data = row
            // },
            seeInfo(row){
                this.editData.state = true
                this.editData.data = row
            },
            // 获取查询列表
            getListFn () {
                this.loading = true;
                getMyRecord(this.paramSearch).then((res)=> {
                    this.loading = false;
                    if(res.data.code == 0){
                        this.list = res.data.data.records || []
                        this.total = res.data.data.total;
                    }
                }).catch(() => {
                    this.loading = false;
                });
            },
            // 默认页面数据
            initPage() {
                this.paramSearch={
                    ...this.paramSearch,
                    ...this.$refs.needSift.getValue(),
                    current:1
                }
                this.getListFn();
            },

            // 条数
            changeSize(value) {
                this.paramSearch.size=value;
                this.paramSearch.current=1;
                this.getListFn();
            },
            // 翻页
            changePage(value) {
                this.paramSearch.current=value;
                this.getListFn();
            },
            handleSelectionChange(val){
                this.selectList = val.map((item) =>{return item.id})
            },
        },
        watch: {},
        filters: {}
    };
</script>

<style scoped  lang="less">
    @import "../../assets/css/handleBtn.less";
    /deep/.el-table {
        width: 100%;
        .el-table__body-wrapper {
            max-height: calc(100vh - 300px);
            overflow-y: auto;

        }
    }
</style>
